import PropTypes from "prop-types";
import AppConfig from "utils/Config";

const CircularProgress = ({ className }) => {
  // Construct the correct spinner path
  const spinnerPath =
    AppConfig.basePath === "/"
      ? "/spinner.gif"
      : `${AppConfig.basePath}spinner.gif`;

  return (
    <div className={`loader ${className}`}>
      <img src={spinnerPath} alt="loader" />
    </div>
  );
};

CircularProgress.propTypes = {
  className: PropTypes.string,
};
export default CircularProgress;
